const isImageIconValue = (value) =>
    /^(?:https?:\/\/|\/|data:image\/|blob:)/i.test(String(value || '').trim());

const isSvgIconValue = (value) => /^\s*<svg[\s>]/i.test(String(value || ''));

export default function IconValue({ value, className = '', style }) {
    const normalizedValue = String(value || '').trim();

    if (isImageIconValue(normalizedValue)) {
        return (
            <span
                className={`inline-flex shrink-0 items-center justify-center leading-none ${className}`}
                style={style}
            >
                <img
                    src={normalizedValue}
                    alt=""
                    aria-hidden="true"
                    className="block h-[1em] w-[1em] object-contain"
                />
            </span>
        );
    }

    if (isSvgIconValue(normalizedValue)) {
        return (
            <span
                className={`inline-flex shrink-0 items-center justify-center leading-none [&>svg]:block [&>svg]:h-[1em] [&>svg]:w-[1em] ${className}`}
                style={style}
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: normalizedValue }}
            />
        );
    }

    return (
        <i
            className={`${normalizedValue} ${className}`.trim()}
            style={style}
            aria-hidden="true"
        />
    );
}
